import styled from 'styled-components';

export const StyledSection = styled.div`
  .survey-wrapper__background {
    padding: 32px 22px;
    background-size: cover;
    background-attachment: fixed;
  }

  @media (min-width: 768px) {
    .survey-wrapper__background {
      padding: 69px 22px 83px 22px;
    }
  }

  .survey-wrapper__children {
    max-width: 980px;
    margin: auto;
    background-image: unset !important;
  }

  .bold {
    font-weight: 700;
  }
`;
